import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toLeft",
  "use": "toLeft-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toLeft\">\n<path d=\"M11.7051 3.11499L7.12508 7.70499L11.7051 12.295L10.2951 13.705L4.29508 7.70499L10.2951 1.70499L11.7051 3.11499Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol